import React, { Component } from 'react';

export class SearchView extends Component {
    static displayName = SearchView.name;

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <h1>Search</h1>
            </div>
        );
    }
}
